import React from 'react';
import { useSentryUser } from '@/hooks/useSentryUser';

/**
 * Provider component that syncs the Supabase auth user with Sentry
 * Wrap your application with this provider to ensure user data is populated in Sentry
 */
export const SentryUserProvider = ({ children }: { children: React.ReactNode }) => {
  useSentryUser(); // This will sync the Supabase user with Sentry
  return <>{children}</>;
};
